import { useTranslation } from 'react-i18next';

const LawyerBillingStatus = () => {
  const { t } = useTranslation();
  const lawyerBilling = {
    totalReceived: 5000,
    status: "Fully Paid",
    released: true,
  };

  return (
    <div className="glass rounded-lg shadow-sm p-6">
      <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
        {t('Lawyer payout summary')}
      </h2>

      <dl className="text-sm text-gray-700 dark:text-gray-300 space-y-4">
        <div className="flex justify-between">
          <dt className="font-medium">{t('Total received')}</dt>
          <dd>${lawyerBilling.totalReceived.toLocaleString()}</dd>
        </div>

        <div className="flex justify-between">
          <dt className="font-medium">{t('Status')}</dt>
          <dd>
            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-success-100 text-success-800 dark:bg-success-900 dark:text-success-300">
              {t(lawyerBilling.status)}
            </span>
          </dd>
        </div>

        <div className="flex justify-between">
          <dt className="font-medium">{t('Payout released')}</dt>
          <dd>
            {lawyerBilling.released ? (
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-info-100 text-info-800 dark:bg-info-900 dark:text-info-300">
                {t('Yes')}
              </span>
            ) : (
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-danger-100 text-danger-800 dark:bg-danger-900 dark:text-danger-300">
                {t('No')}
              </span>
            )}
          </dd>
        </div>
      </dl>
    </div>
  );
};

export default LawyerBillingStatus;
